import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { fromCityTypeByLabelSelector } from 'reduxModules/selectors/CitySelectors'

import { BlacklistBooking as View } from './BlacklistBooking'

const mapStateToProps = createStructuredSelector({
  fromCityTypeByLabel: fromCityTypeByLabelSelector
})

export const BlacklistBooking = connect(mapStateToProps)(View)


// WEBPACK FOOTER //
// ./src/components/BlacklistBookings/components/BlackistBooking/index.js